(function() { window.GUID_2b4dc8b1_b1c5_4052_8966_9fd2e666501c = { getGuid: function() { return "2b4dc8b1-b1c5-4052-8966-9fd2e666501c"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let EventsLinkerValidationErrorCode;
        (function (EventsLinkerValidationErrorCode) {
            EventsLinkerValidationErrorCode[EventsLinkerValidationErrorCode["SomeFirstNamesDontMatch"] = 1] = "SomeFirstNamesDontMatch";
            EventsLinkerValidationErrorCode[EventsLinkerValidationErrorCode["SomeLastNamesDontMatch"] = 2] = "SomeLastNamesDontMatch";
            EventsLinkerValidationErrorCode[EventsLinkerValidationErrorCode["SomeNamesDontMatch"] = 3] = "SomeNamesDontMatch";
            EventsLinkerValidationErrorCode[EventsLinkerValidationErrorCode["AllFirstNamesDontMatch"] = 4] = "AllFirstNamesDontMatch";
            EventsLinkerValidationErrorCode[EventsLinkerValidationErrorCode["AllLastNamesDontMatch"] = 5] = "AllLastNamesDontMatch";
            EventsLinkerValidationErrorCode[EventsLinkerValidationErrorCode["AllNamesDontMatch"] = 6] = "AllNamesDontMatch";
            EventsLinkerValidationErrorCode[EventsLinkerValidationErrorCode["CantLinkToThatPlayer"] = 7] = "CantLinkToThatPlayer";
        })(EventsLinkerValidationErrorCode = Enumeration.EventsLinkerValidationErrorCode || (Enumeration.EventsLinkerValidationErrorCode = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=EventsLinkerValidationErrorCode.pre.js.map
